module.exports = __webpack_public_path__ + "img/attendance.89c12df9.svg";